module.exports = "./img/7c84fa0aad51510d00b8cab1d010af99.png";